import { defineMessages } from '@edx/frontend-platform/i18n'

const messages = defineMessages({
  courses: {
    id: "pages.program-single.courses",
    defaultMessage: "courses",
    description: "courses count label"
  },
  addToCart: {
    id: "pages.program-single.addToCart",
    defaultMessage: "Add to Cart",
    description: "add to cart button text"
  },
  removeFromCart: {
    id: "pages.program-single.removeFromCart",
    defaultMessage: "Remove from Cart",
    description: "remove from cart button text"
  },
  addToWishlist: {
    id: "pages.program-single.addToWishlist",
    defaultMessage: "Add to Wishlist",
    description: "add to wishlist button text"
  },
  removeFromWishlist: {
    id: "pages.program-single.removeFromWishlist",
    defaultMessage: "Remove from Wishlist",
    description: "remove from wishlist button text"
  },
  viewCourse: {
    id: "pages.program-single.viewCourse",
    defaultMessage: "View Course",
    description: "view course button text"
  },
  description: {
    id: "pages.program-single.description",
    defaultMessage: "Description",
    description: "description title"
  },

  noDescriptionFound: {
    id: "pages.program-single.noDescriptionFound",
    defaultMessage: "No description found",
    description: "no description found text"
  },
  about: {
    id: "pages.program-single.about",
    defaultMessage: "About",
    description: "about title"
  },
  noAboutFound: {
    id: "pages.program-single.noAboutFound",
    defaultMessage: "No about found",
    description: "no about found text"
  },
  contents: {
    id: "pages.program-single.contents",
    defaultMessage: "Contents",
    description: "contents title"
  },
  noCoursesFound: {
    id: "pages.program-single.noCoursesFound",
    defaultMessage: "No courses found",
    description: "no courses found text"
  }
})

export default messages;